import React, { useMemo, useCallback } from 'react';
import { BodyTextRegularB, BodyTextMediumA } from '@/shared/ui/typography2';
import { WrapperOptions, OptionItem, InfoEl, OptionIcon } from './styles';
import { brandIsPh } from '@/shared/config/brand-by-target.mjs';
import { OPTION_IMAGES } from '@/flat-pages/bonuses/model/utils';
import { useFormatAmount } from '@/shared/hooks/useFormatAmount';
import type { Translate } from '@locales/client';

export interface BonusOption {
  text: string;
  minDeposit: number;
}

interface OptionsBlockProps {
  options?: BonusOption[];
  changeConditionActive: (index: number) => void;
  conditionActive: number | null;
  t: Translate;
}

export const OptionsBlock = React.memo(
  ({
    options,
    changeConditionActive,
    conditionActive,
    t,
  }: OptionsBlockProps) => {
    const handleOptionClick = useCallback(
      (index: number) => {
        changeConditionActive(index);
      },
      [changeConditionActive]
    );

    const shouldRender = useMemo(
      () => (options?.length ?? 0) > 1,
      [options?.length]
    );
    const formatAmount = useFormatAmount();

    if (!shouldRender || !options) return null;

    return (
      <WrapperOptions>
        {options.map((el, index) => {
          const text = el?.text;
          const minDeposit = el?.minDeposit;
          const isActive = index === conditionActive;
          const coinImage =
            OPTION_IMAGES[index as keyof typeof OPTION_IMAGES] ||
            OPTION_IMAGES[0];

          return (
            <OptionItem
              key={`${text}-${minDeposit}-${index}`}
              onClick={() => handleOptionClick(index)}
              $isActive={isActive}
            >
              <OptionIcon src={coinImage} alt={brandIsPh ? 'gift' : 'coin'} />
              <InfoEl>
                <BodyTextMediumA color={isActive ? '#FF9F0A' : '#fff'}>
                  {text}
                </BodyTextMediumA>
                <BodyTextRegularB color="#AFAFAF">
                  {t('card.deposit_from', {
                    value: formatAmount(minDeposit),
                  })}
                </BodyTextRegularB>
              </InfoEl>
            </OptionItem>
          );
        })}
      </WrapperOptions>
    );
  }
);
